export const apiKey = process.env.REACT_APP_API_KEY;
export const API_URL = process.env.REACT_APP_API_URL;
export const getToken = () => {
  return sessionStorage.getItem('token'); // Always fetch token dynamically
};

 